import EventBus from "@/lib/utilities/eventBus.js";
import { EventBusEvents } from "@/lib/utilities/enums";
import CXMApiClient from "../../CXMApiClient";

const state = {
  CreditRequests: null,
  SevenHundredCreditResultsModalInfo: {
    ShowModal: false,
    Data: null
  }
};

const getters = {
  SevenHundredCreditResultsModalInfo(state) {
    return state.SevenHundredCreditResultsModalInfo;
  }
};

const actions = {
  async getCreditRequests(context, contactId) {
    if (contactId < 1) return null;

    const request = {
      contactId: contactId
    };
    let cxmApiClient = new CXMApiClient();

    const response = await cxmApiClient.ProcessRequest(
      "POST",
      "/api/credit/contact_credit_requests",
      request
    );

    if (response && response.data && response.data.successful)
      context.commit("gotCreditRequests", response.data.data);
    else {
      EventBus.$emit(EventBusEvents.DISPLAY_SNOTIFY_NOTIFICATION, {
        type: "error",
        message:
          "There was an error loading the credit history details. Please try again later."
      });
    }

    return response.data.data;
  },
  async getSevenHundredBaseRequest(context, request) {
    if (request.applicantContactId < 1) return null;
    let cxmApiClient = new CXMApiClient();

    const response = await cxmApiClient.ProcessRequest(
      "POST",
      "/api/credit/sevenhundredcredit/create_base_request",
      request
    );

    return response.data.data;
  },
  async sevenHundredPreScreen(context, request) {
    if (request.applicantContactId < 1) return null;
    let cxmApiClient = new CXMApiClient();
    const response = await cxmApiClient.ProcessRequest(
      "POST",
      "/api/credit/sevenhundredcredit/pre_screen",
      request
    );

    return response.data.data;
  },

  async checkCreditRequestStatus(context, request) {
    if (request.applicantContactId < 1) return null;
    let cxmApiClient = new CXMApiClient();
    const response = await cxmApiClient.ProcessRequest(
      "POST",
      "/api/credit/credit_request_status",
      request
    );

    return response.data.data;
  },
  setSevenHundredCreditResultsModal(context, val) {
    context.commit("setSevenHundredCreditResultsModal", val);
  },
  clearSevenHundredCreditResultsModal(context) {
    context.commit("clearSevenHundredCreditResultsModal");
  }
};

const mutations = {
  clearSevenHundredCreditResultsModal(state) {
    state.SevenHundredCreditResultsModalInfo = {
      ShowModal: false,
      Data: null
    };
  },
  setSevenHundredCreditResultsModal(state, val) {
    state.SevenHundredCreditResultsModalInfo = val;
  },
  gotCreditRequests(state, data) {
    state.CreditRequests = data;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/customerdashboard/Credit.js